import { useCallback } from "react";

import { DraftUpdater, WorkDraftMap, WorkKind } from "../types";
import { useWorkQueueSession } from "../WorkQueueProvider";

export const useQueueDraft = <K extends WorkKind>(kind: K, key: string) => {
  const { drafts, updateDraft } = useWorkQueueSession();
  const kindDrafts: Record<string, WorkDraftMap[K]> = drafts[kind];
  const draft: WorkDraftMap[K] | null = kindDrafts[key] ?? null;

  const update = useCallback(
    (updater: DraftUpdater<WorkDraftMap[K]>) => updateDraft(kind, key, updater),
    [kind, key, updateDraft],
  );

  return [draft, update] as const;
};
